function accordionsCreate() {
  $('.accordion .title').on('click', function(){
    const el = $(this)

    toggleTextHint(el);

    el.toggleClass('active')
    el.parent('.accordion')
        .find('.collapse')
        .slideToggle('fast')
  })
}

function toggleTextHint(el) {
  if(!$(el).hasClass('active')) {
    $(el).find('.new-car-datasheet-icon span').html('MENOS');

    $(el).find('.new-car-datasheet-icon i')
      .addClass('icon-seta-para-cima')
      .removeClass('icon-seta-para-baixo')
  } else {
    $(el).find('.new-car-datasheet-icon span').html('MAIS');

    $(el).find('.new-car-datasheet-icon i')
      .addClass('icon-seta-para-baixo')
      .removeClass('icon-seta-para-cima');
  }
}

module.exports = {
  accordionsCreate
}
